import script from "./addUsersToFacility.vue?vue&type=script&setup=true&lang=js"
export * from "./addUsersToFacility.vue?vue&type=script&setup=true&lang=js"

import "./addUsersToFacility.vue?vue&type=style&index=0&id=194a7332&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194a7332"]])

export default __exports__